import ScrollSpyManager from "../../services/scrollSpyManager";
import BookingSummaryService from "../../services/book/bookingSummaryService";
import BookingService from "../../services/book/bookingService";
import Step1Manager from "../../services/book/step1Manager";
import DatesFormValidator from "../../services/forms/validator/book/datesFormValidator";

$(function ()
{
    myApp.form.validator.datesFormValidator = new DatesFormValidator();
    myApp.step1Manager = new Step1Manager();
    if(myApp.activitiesDiscountsJson) {
        myApp.step1Manager.activitiesDiscountsJson = myApp.activitiesDiscountsJson;
    }
    myApp.scrollSpyManager = new ScrollSpyManager();

    myApp.bookingSummaryService = new BookingSummaryService();
    myApp.step1Manager.initialize();
    myApp.bookingService = new BookingService();
    myApp.bookingService.booking.setAdults(0);
    myApp.bookingService.booking.setChildren(0);
    myApp.bookingConfigurator.removeDataFromBrowserStorage();
    myApp.bookingConfigurator.setDataFromBrowserStorage();
    myApp.bookingConfigurator.refreshDatesPrice();
});
